import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import 'antd/dist/antd.css';
import './assets/css/index.css';

import CkuDashboard from './services/user/CkuDashboard';
import SndDashboard from './services/user/SndDashboard';
import I18nLoader from './services/i18n';
import ErrorPage from './services/components/ErrorPage';
import PrivateRoute from './routes/PrivateRoute';
import theme from './setupTheme';
import setupStore from './setupStore';
// import registerServiceWorker from './registerServiceWorker';
import { Login } from './services/auth';

import i18n from 'react-intl-universal';
import { ERROR_PAGE_URL, NOT_FOUND_PAGE_URL } from './services/urls';
import ErrorBoundary from './services/ErrorBoundary';
import ErrorBroker from './services/utils/errorBroker';
import AuthLoader from 'cm-react/lib/services/auth/AuthLoader';
import { setupSocialSDKs } from 'cm-react/lib/services/auth/Social/setup';

// avoid socket calls for pace.js
if (window.Pace) {
  window.Pace.options.ajax.trackWebSockets = false;
}

let errorBroker = null;
if (process.env.NODE_ENV === 'production') {
  const sentryDSN = process.env.REACT_APP_SENTRY_DSN;
  if (sentryDSN) {
    errorBroker = new ErrorBroker({ dsn: sentryDSN });
  }
}

const history = createBrowserHistory();
const onRehydrationComplete = store => {
  setupSocialSDKs(store);
};

const { store, persistor } = setupStore({
  history,
  errorBroker,
  onRehydrationComplete
});

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <MuiThemeProvider theme={theme}>
          <AuthLoader>
            <I18nLoader>
              <ErrorBoundary broker={errorBroker}>
                <ConnectedRouter history={history}>
                  <Switch>
                    <Route exact path="/login/" component={Login} />
                    <Route
                      path={ERROR_PAGE_URL}
                      render={() => (
                        <ErrorPage
                          title={i18n.get('app.ErrorPage.serverError.title')}
                          body={i18n.get('app.ErrorPage.serverError.body')}
                        />
                      )}
                    />
                    <Route
                      path={NOT_FOUND_PAGE_URL}
                      render={() => (
                        <ErrorPage
                          title={i18n.get('app.ErrorPage.notFound.title')}
                          body={i18n.get('app.ErrorPage.notFound.body')}
                        />
                      )}
                    />
                    <PrivateRoute exact path="/" component={SndDashboard} />
                    <PrivateRoute exact path="/cb/" component={CkuDashboard} />
                    <Route
                      render={() => (
                        <ErrorPage
                          title={i18n.get('app.ErrorPage.notFound.title')}
                          body={i18n.get('app.ErrorPage.notFound.body')}
                        />
                      )}
                    />
                  </Switch>
                </ConnectedRouter>
              </ErrorBoundary>
            </I18nLoader>
          </AuthLoader>
        </MuiThemeProvider>
      </PersistGate>
    </Provider>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
